<div class="fullcontainer">
  <br />
  <br />
  <div class='titleContainer'>
    <h2 class='header'>Inspection &amp; MOT Calendar</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/workshop/inspections'><i class="fas fa-clipboard-list"></i> List</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/workshop/inspections/bulk'><i class="fas fa-layer-group"></i> Bulk add</button>&nbsp;
    </div>
  </div>
  <br />

  <div class="form-row">
    <div class="form-group col-md-3">
      <label>Inspection type</label>
      <select class="form-control" [(ngModel)]='this.typeId' (change)='this.load()'>
        <option [ngValue]='-1'>All inspections</option>
        @for (t of this.types; track t.id) { <option [ngValue]='t.id'>{{ t.name }}</option> }
      </select>
    </div>
    <div class="form-group col-md-3">
      <label>Vehicle</label>
      <select class="form-control" [(ngModel)]='this.vehicleId' (change)='this.load()'>
        <option [ngValue]='-1'>All vehicles</option>
        @for (v of this.vehicles; track v.id) { <option [ngValue]='v.id'>{{ v.registration }}</option> }
      </select>
    </div>
    <div class="form-group col-md-6 legend">
      @for (t of this.legend(); track t.id) {
        <span class='legendItem'><span class='swatch' [style.background]='t.colour'></span>{{ t.name }}</span>
      }
      <span class='legendItem'><span class='swatch overdue'></span>Overdue</span>
    </div>
  </div>

  @if (this.error) { <div class="alert alert-danger">{{ this.error }}</div> }
  @if (this.overdueCount) {
    <div class="alert alert-warning">{{ this.overdueCount }} inspection(s) in this view are overdue.</div>
  }

  <div class='calendarCard'>
    <div class="calendarToolbar">
      <div class="btn-group">
        <div class="btn btn-secondary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="this.onViewDateChange()">Previous</div>
        <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate" (viewDateChange)="this.onViewDateChange()">Today</div>
        <div class="btn btn-secondary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="this.onViewDateChange()">Next</div>
      </div>
      <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en':weekStartsOn }}</h3>
      <div class="btn-group">
        <div class="btn btn-secondary" (click)="this.setView(CalendarView.Month)" [class.active]="view === CalendarView.Month">Month</div>
        <div class="btn btn-secondary" (click)="this.setView(CalendarView.Week)" [class.active]="view === CalendarView.Week">Week</div>
      </div>
    </div>

    @if (this.loading) { <p class='text-muted'>Loading&hellip;</p> }

    @switch (view) {
      @case (CalendarView.Month) {
        <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" [weekStartsOn]="weekStartsOn"
          [cellTemplate]="inspectionCell">
        </mwl-calendar-month-view>
      }
      @case (CalendarView.Week) {
        <mwl-calendar-week-view [viewDate]="viewDate" [events]="events" [weekStartsOn]="weekStartsOn"
          [hourSegments]="1" [dayStartHour]="7" [dayEndHour]="8" (eventClicked)="this.eventClicked($event)">
        </mwl-calendar-week-view>
      }
    }
  </div>

  <!-- Month cells list every inspection due that day, so the whole month can be read at a glance. -->
  <ng-template #inspectionCell let-day="day">
    <div class="inspectionCell" [class.otherMonth]="!day.inMonth">
      <span class="dayNumber" [class.today]="day.isToday">{{ day.date | calendarDate:'monthViewDayNumber':'en' }}</span>
      @for (event of day.events; track event) {
        <div class="inspectionChip" [class.overdue]="event.meta.overdue" [style.border-left-color]="event.meta.colour"
          [title]="event.title" (click)="this.eventClicked({ event: event }); $event.stopPropagation()">
          {{ event.meta.registration }} <span class="chipType">{{ event.meta.typeName }}</span>
        </div>
      }
    </div>
  </ng-template>

  <app-inspection-action-modal [target]='this.target' mode='complete' (saved)='this.load()'></app-inspection-action-modal>
</div>
